export function MapSidebar() {
  return (
    <aside className="flex-1 sticky top-[110px] h-fit max-md:static">
      <div className="bg-white p-5 shadow-[0_2px_10px_rgba(0,0,0,0.1)]">
        <h3 className="mb-[15px] text-[#333] text-base">
          Karklėnų g. 21, Vilnius 11223
        </h3>
        <iframe
          className="w-full h-[400px] border-none rounded"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2304.6894!2d25.427521!3d54.689394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTTCsDQxJzIxLjgiTiAyNcKwMjUnMzkuMSJF!5e0!3m2!1slt!2slt!4v1234567890"
          allowFullScreen
          loading="lazy"
          title="Google Maps"
        />
      </div>
    </aside>
  );
}
